export enum InsuredRelationshipEnum {
  Spouse = 1,
  Self = 2,
  Child = 3,
  Employee = 4,
  Unknown = 5,
  OrganDonor = 6,
  CadaverDonor = 7,
  LifePartner = 8,
  Other = 9
}

export const InsuredRelationshipOptions = [
{ id: 1, label: 'Spouse' },
{ id: 2, label: 'Self' },
{ id: 3, label: 'Child' },
{ id: 4, label: 'Employee' },
{ id: 5, label: 'Unknown' },
{ id: 6, label: 'Organ Donor' },
{ id: 7, label: 'Cadaver Donor' },
{ id: 8, label: 'Life Partner' },
{ id: 9, label: 'Other' }
];
